export default theme => ({
  root: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '@global': {
    'html, body, #root': {
      height: '100%',
    },
    'html,body,p,h1,h2,h3,h4,h5,h6' :{
        lineHeight: 2
    },
    'html, body, input, textarea, button' :{
      fontFamily: 'IRANSans',
      // fontSize: 13,
    },
    body: {
      textAlign: 'right',
      background: '#fefefe'
    },
    a: {
      textDecoration: 'none',
      color: '#303030',
      '&:hover': {
        color: '#fc4a38'
      },
      '&:visited': {
          color: '#4a4a4a'
      },
      '&:visited:hover': {
          color: '#fc6151'
      }
    },
    ul: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
    },
  },
  cover: {
    flexGrow: 1,
    width: '100%',
    height: 649,
    marginBottom: -20,
    backgroundImage: 'url(/caffecinema/img/404-bg-with-text-1280.jpg)',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#000',
  }
});